import * as Yup from 'yup';

import {
  MINIMUM_PASSWORD_LENGTH,
  REGEX_CONTAINS_ONE_LETTER_MINIMUM,
  REGEX_CONTAINS_ONE_NUMBER_MINIMUM,
} from '../../../constants';
import { isPasswordStrong } from '../../../validators';

export const passwordSchema = Yup.string()
  .label('Password')
  .required()
  .min(MINIMUM_PASSWORD_LENGTH, `${MINIMUM_PASSWORD_LENGTH} characters required`)
  .matches(REGEX_CONTAINS_ONE_NUMBER_MINIMUM, 'one digit required')
  .matches(REGEX_CONTAINS_ONE_LETTER_MINIMUM, 'one letter required')
  .test('isPasswordStrong', 'avoid common passwords', isPasswordStrong);
